import React from 'react'
import Http from '../Http';
import TableComponent, { TableOp } from './table/TableOps';

export default class PreguiaLog extends TableComponent {

  componentDidMount() {
    // this.cargarLog();
    let pgId = this.props.preguia.id;
    this.tableConfig(
      { dataUrl: `preguia/${pgId}/log`, deleteUrl: '', deleteField: '', modUrl: '' },
      TableOp.Table(false, [
        // { label: 'Clave', id: 'id' },
        { label: 'Estado', id: 'preguia_estado' },
        { label: 'Usuario', id: 'usuario' },
        { label: 'Fecha de Modificación', id: 'createdAt' },
        // { label: 'Programada', id: 'pg_pro_fecha' },
        // { label: 'Receptor', id: 'pg_receptor' },
      ], [
        // { id: 'cancel', icon: 'cancel' },
      ]))
    this.rpp = 100;
    this.table(0, 100);
  }

  cargarLog = async () => {
    let pgId = 59;
    try {
      let Res = await Http.get(`preguia/${pgId}/log`);
      console.log(Res)
      if (!Res.error) {

      }
    } catch (error) {

    }
  }

  render() {
    return (
      <this.TableRender />
    )
  }
}
